import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService} from '../../../shared/services/auth.service';
import {ThemeService} from '../../../shared/services/theme.service';
import {Observable} from 'rxjs';
import {User} from '../../../shared/models/user';
import {Router} from "@angular/router";

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
    @Output()
    menuToggle: EventEmitter<void> = new EventEmitter<void>();

    user$: Observable<User>;
    darkMode$: Observable<boolean>;

    constructor(
        private auth: AuthService, 
        private router: Router,
        public themeService: ThemeService
    ) {
    }

    ngOnInit() {
        this.user$ = this.auth.user$;
        this.darkMode$ = this.themeService.darkMode$;
    }

    async logout() {
        await this.auth.logout();
        this.router.navigate(['login']);
    }

    toggleDarkMode() {
        this.themeService.toggleDarkMode();
    }

}
